<template>
	<!-- To be filled by specific implementations -->
</template>

<script>
import SelectBaseComponent from "@/components/templates/common/SelectBaseComponent";

export default {
	extends: SelectBaseComponent,
	props: {
		optionsChildrenField: { type: String, default: "children" },
		api: { type: Function, default: null }, // API function to load options
		showOnlyChecked: { type: Boolean, default: false }
	},
	created() {
		if (this.optionsKeyField && (this.optionsKeyField !== this.optionsValueField)) {
			console.error("tree select needs option keys and values to be equal");
		}

		if (this.optionsKeyGetter || this.optionsValueGetter) {
			console.error("tree select does not support key or value getters yet");
		}

		// make sure keys field is set equal to values
		this.optionsKeyField = this.optionsValueField;

		// Make sure to use the provided tree filtering instead
		this.searchCustom = true;

		// Tree needs at least an empty array at the start
		this.options = [];

		if (this.api) {
			this.loadDataFromApi();
		}
	},
	mounted() {
		this.syncTreeState();
	},
	computed: {
		treeProperties() {
			return {
				children: this.optionsChildrenField,
				// the tree does not support getter functions or nested paths here, so we manually map it based on the options' field configuration
				label: "node_label",
				nodeKey: "node_key",
			}
		},
	},
	methods: {
		isTreeRendered() {
			return !!this.$refs.tree;
		},
		filterTreeNode(_, data, node) {
			if (this.showOnlyChecked && !node.checked) {
				return false;
			}

			return !this.searchValue || data[this.treeProperties.label].toLowerCase().includes(this.searchValue.toLowerCase());
		},
		onNodeChecked() {
			const checkedValues = this.$refs.tree.getCheckedNodes(true).map(this.getOptionValue);

			this.$emit("input", checkedValues);
			this.$emit("md-selected", checkedValues);

			if (this.showOnlyChecked) {
				this.applyTreeFilter();
			}
		},
		expandAll() {
			if (this.showOnlyChecked) {
				this.expandVisible();
			} else {
				this.callOnAllNodes((node) => node.expanded = true);
			}
		},
		collapseAll() {
			if (this.showOnlyChecked) {
				this.collapseVisible();
			} else {
				this.callOnAllNodes((node) => node.expanded = false);
			}
		},
		expandVisible() {
			this.callOnAllNodes((node) => {
				if (node.visible) {
					node.expanded = true;
				}
			});
		},
		collapseVisible() {
			this.callOnAllNodes((node) => {
				if (node.visible) {
					node.expanded = false;
				}
			});
		},
		callOnAllNodes(func) {
			const traverseOptionsAsNodes = (options) => {
				options.forEach(option => {
					let node = this.$refs.tree.getNode(option[this.treeProperties.nodeKey]);

					func(node);

					let children = option[this.treeProperties.children];
					if (children) {
						traverseOptionsAsNodes(children);
					}
				});
			};
			traverseOptionsAsNodes(this.options);
		},
		applyTreeFilter() {
			if (this.isTreeRendered()) {
				this.$refs.tree.filter();
			}
		},
		syncTreeState() {
			if (this.isTreeRendered()) {
				this.applyTreeFilter();
				this.$refs.tree.setCheckedKeys(this.value || []);
			}
		},
		loadDataFromApi() {
			this.api()
				.then(res => {
					this.options = res;
					this.options.forEach(this.recursiveUpdateOptionWithNodeData);
				})
				.catch(this.toast);
		},
		recursiveUpdateOptionWithNodeData(option) {
			option[this.treeProperties.nodeKey] = this.getOptionValue(option);
			option[this.treeProperties.label] = this.getOptionDisplayValue(option);

			let children = option[this.treeProperties.children];
			if (children) {
				children.forEach(child => this.recursiveUpdateOptionWithNodeData(child));
			}
		}
	},
	watch: {
		searchValue() {
			this.applyTreeFilter();
		},
		value() {
			this.syncTreeState();
		},
		options() {
			this.syncTreeState();
		},
		showOnlyChecked() {
			this.applyTreeFilter();

			if (this.showOnlyChecked) {
				this.expandVisible();
			}
		}
	},
};
</script>
